import Snackbar from '@material-ui/core/Snackbar';

export default Snackbar;
